<script setup>
import { computed, ref, watch } from 'vue';
import store from '@/store';

const loading = ref(true);

const setting_image = computed(() => store.state.imageSettings || {});

watch(
  () => store.state.imageSettings,
  (newValue) => {
    if (newValue && newValue.background_login && newValue.background_login.value) {
        loading.value = false;
    } else {
      setTimeout(() => {
        loading.value = false;
      }, 500);
    }
  },
  { immediate: true }
);

const background = computed(() => {
  if (loading.value) return '';

  if (setting_image.value && setting_image.value.background_login && setting_image.value.background_login.value) {
    return setting_image.value.background_login.value;
  }

  return `/img/backgrounds/farm-${Math.floor(Math.random() * 3)}.jpg`;
});
</script>

<template>
	<div v-loading="loading" class="header py-7 py-lg-8 pt-lg-9" :style="'background: rgba(0, 0, 0, 0) url('+background+') repeat scroll 0% 0% / cover;'">
		<div class="container">
			<div class="header-body text-center mb-7">
			</div>
		</div>
		<div class="separator separator-bottom separator-skew zindex-100">
			<svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
				xmlns="http://www.w3.org/2000/svg">
			</svg>
		</div>
		<div id="page-content" class="container mt--8 pb-5" style="margin-top: -20rem !important;">
			<slot name="layout"></slot>
		</div>
	</div>
</template>
